<template>
    <div
        class="cupons-table-page text-start"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <v-container class="p-0" fluid>
            <div class="page-card">
                <div class="d-flex justify-content-between align-items-start">
                    <div>
                        <h1 class="card-title mb-2">Cupons</h1>
                        <p class="card-subtitle mb-4 mb-md-0">
                            Gerencie os cupons do sistema.
                        </p>
                    </div>
                    <button
                        class="btnd btnd--purple btnd--prepend-icon text-capitalize pr-4 pr-md-6"
                        @click="newCupomDialog = true"
                        title="Criar novo cupom"
                    >
                        <Icon name="plus" size="20" class="mr-0 mr-md-2" />
                        <span class="d-none d-md-block">Novo cupom</span>
                    </button>
                </div>
                <hr class="page-card__divider" />

                <v-row class="mt-1 mb-2" justify-sm="space-between">
                    <v-col cols="12" sm="7" md="5" lg="4">
                        <v-text-field
                            v-model="searchTerm"
                            label="Pesquisar cupons"
                            class="inputd"
                            variant="outlined"
                            density="compact"
                            hide-details
                            @update:model-value="onSearch"
                        >
                            <template v-slot:append-inner>
                                <Icon name="magnifyingGlass" size="20" />
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col
                        cols="12"
                        sm="5"
                        md="4"
                        lg="6"
                        style="display: flex; gap: 10px"
                    >
                        <v-select
                            v-model="statusFilter"
                            :items="statusFilterOptions"
                            item-title="text"
                            item-value="value"
                            label="Status"
                            variant="outlined"
                            class="inputd"
                            @update:modelValue="getCupomData()"
                            density="compact"
                            hide-details
                        />
                    </v-col>
                </v-row>

                <div data-aos="fade-up" data-aos-duration="1500">
                    <v-table class="custom-table">
                        <thead>
                            <tr>
                                <th class="cupons-table__name-column">
                                    Título
                                </th>
                                <th>Código</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Vencimento</th>
                                <th class="text-center">Desconto</th>
                                <th class="text-center">Editar</th>
                                <th class="text-center">Excluir</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="cupom in cuponsData" :key="cupom.id">
                                <td class="cupons-table__name-column">
                                    {{ cupom.title }}
                                </td>
                                <td>{{ cupom.code }}</td>
                                <td class="text-center">
                                    <v-chip
                                        density="compact"
                                        :color="
                                            cupom.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                    >
                                        {{
                                            cupom.status && cupom.status == 1
                                                ? 'Ativo'
                                                : 'Inativo'
                                        }}
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center">
                                        <v-tooltip
                                            v-if="
                                                getCouponStatus(cupom.expired)
                                                    .showTooltip
                                            "
                                            :text="
                                                getCouponStatus(cupom.expired)
                                                    .message
                                            "
                                            location="top"
                                        >
                                            <template
                                                v-slot:activator="{ props }"
                                            >
                                                <div
                                                    v-bind="props"
                                                    style="
                                                        display: flex;
                                                        align-items: center;
                                                        gap: 5px;
                                                    "
                                                >
                                                    <span
                                                        :style="{
                                                            color: getCouponStatus(
                                                                cupom.expired
                                                            ).color,
                                                        }"
                                                    >
                                                        {{
                                                            new Date(
                                                                cupom.expired
                                                            ).toLocaleDateString()
                                                        }}
                                                    </span>
                                                    <Icon 
                                                        :name="getCouponStatus(cupom.expired).icon" 
                                                        size="20"
                                                        :style="{
                                                            color: getCouponStatus(
                                                                cupom.expired
                                                            ).iconFill,
                                                        }"
                                                    />
                                                </div>
                                            </template>
                                        </v-tooltip>
                                        <span v-else>
                                            {{
                                                new Date(
                                                    cupom.expired
                                                ).toLocaleDateString()
                                            }}
                                        </span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    {{ cupom.discount }}%
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="heading"
                                        @click="editCupom(cupom)"
                                        title="Editar cupom"
                                        icon
                                        variant="text"
                                    >
                                        <Icon name="pencil" size="20" />
                                    </v-btn>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="danger"
                                        variant="text"
                                        @click="openDeleteModal(cupom.id)"
                                        icon
                                        title="Excluir cupom"
                                    >
                                        <Icon name="trash" size="20" />
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>

                <v-responsive>
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="5"
                        :disabled="isLoading"
                        @update:model-value="getCupomData"
                    ></v-pagination>
                </v-responsive>

                <Loader :isActive="!isLoading" />
            </div>
        </v-container>

        <!-- Dialog Novo Cupom -->
        <v-dialog v-model="newCupomDialog" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">Criar Novo Cupom</h3>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="newCupom.title"
                        label="Título do Cupom"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="newCupom.code"
                        label="Código do Cupom"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="newCupom.discount"
                        label="Desconto (%)"
                        type="number"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="newCupom.expired"
                        label="Data de Vencimento"
                        type="date"
                        required
                        class="inputd"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="newCupomDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        variant="flat"
                        @click="createNewCupom"
                        :disabled="!newCupom.title || isLoading"
                        :loading="isLoading"
                        >Criar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Editar Cupom -->
        <v-dialog v-model="editCupomDialog" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">Editar Cupom</h3>
                </v-card-title>
                <v-card-text class="dialog-content">
                    <div class="status-switch">
                        <label>Status</label>
                        <v-switch
                            v-model="editingCupom.status"
                            :label="
                                editingCupom.status === 1 ? 'Ativo' : 'Inativo'
                            "
                            :true-value="1"
                            :false-value="0"
                            color="#2f2e8b"
                            class="dialog-switch"
                        ></v-switch>
                    </div>
                    <v-text-field
                        v-model="editingCupom.title"
                        label="Título do Cupom"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="editingCupom.code"
                        label="Código do Cupom"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="editingCupom.discount"
                        label="Desconto (%)"
                        type="number"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="editingCupom.expired"
                        label="Data de Vencimento"
                        type="date"
                        required
                        class="dialog-input"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="editCupomDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        variant="flat"
                        @click="updateCupom(editingCupom.id)"
                        :disabled="!editingCupom.title || isLoading"
                        :loading="isLoading"
                        >Salvar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Deletar Cupom -->
        <v-dialog v-model="isDeleteDialogVisible" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">
                        Você tem certeza que deseja excluir esse cupom?
                    </h3>
                </v-card-title>
                <v-card-subtitle>
                    Esta ação não poderá ser desfeita.
                </v-card-subtitle>
                <v-card-text>
                    <p class="mb-1">
                        Título: <strong>{{ deletedCupom.title }}</strong>
                    </p>
                    <p class="mb-1">
                        Código: <strong>{{ deletedCupom.code }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="isDeleteDialogVisible = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1 text-white"
                        color="danger"
                        variant="flat"
                        :loading="isLoading"
                        :disabled="isLoading"
                        @click="confirmDelete"
                        >Excluir</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { toast } from 'vue3-toastify';
    import { mapState } from 'vuex';
    import { debounce } from 'lodash';
    import ApiCupom from '@/utils/cupom';
    import Loader from '@/components/Loader/loader.vue';

    export default {
        components: {
            Loader,
        },
        data() {
            return {
                cuponsData: [],
                searchTerm: '',
                currentPage: 1,
                itemsPerPage: 12,
                totalPages: 0,
                isDeleteDialogVisible: false,
                deletedCupom: null,
                isLoading: false,
                statusFilter: '',
                statusFilterOptions: [
                    { text: 'Todos', value: '' },
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 },
                ],
                newCupomDialog: false,
                editCupomDialog: false,
                newCupom: {
                    title: '',
                    code: '',
                    discount: '',
                    expired: '',
                },
                editingCupom: {
                    id: '',
                    title: '',
                    code: '',
                    discount: '',
                    expired: '',
                    status: 1,
                },
            };
        },
        computed: {
            ...mapState(['token', 'numberIntensTable']),
        },
        created() {
            this.getCupomData();
        },
        methods: {
            getCouponStatus(expiredDate) {
                const expirationDate = new Date(expiredDate);
                const currentDate = new Date();
                const timeDifference =
                    expirationDate.getTime() - currentDate.getTime();
                const daysDifference = Math.ceil(
                    timeDifference / (1000 * 60 * 60 * 24)
                );

                if (daysDifference < 0) {
                    return {
                        showTooltip: true,
                        message: 'Seu cupom está expirado!',
                        color: '#dc3545',
                        iconColor: '#fee7e7',
                        iconFill: '#dc3545',
                        icon: 'alertCircle',
                    };
                }

                if (daysDifference >= 0 && daysDifference <= 7) {
                    return {
                        showTooltip: true,
                        message: 'Seu cupom vai expirar logo!',
                        color: '#ff9800',
                        iconColor: '#fff3e0',
                        iconFill: '#ff9800',
                        icon: 'alert',
                    };
                }

                return {
                    showTooltip: false,
                    message: '',
                    color: 'inherit',
                    iconColor: '',
                    iconFill: '',
                    icon: '',
                };
            },
            openDeleteModal(cupomId) {
                this.deletedCupom = this.cuponsData.find(
                    (cupom) => cupom.id === cupomId
                );
                if (!this.deletedCupom) {
                    toast.error('Cupom não encontrado');
                    return;
                }
                this.isDeleteDialogVisible = true;
            },
            editCupom(cupom) {
                this.editingCupom = { ...cupom };
                this.editCupomDialog = true;
            },
            async getCupomData() {
                try {
                    this.isLoading = true;
                    let status = this.statusFilter;
                    if (status === '') status = null;
                    let search =
                        this.searchTerm && this.searchTerm.trim() !== ''
                            ? this.searchTerm.trim()
                            : null;

                    const response = await ApiCupom.getDataCupons(
                        this.token,
                        this.currentPage - 1,
                        this.itemsPerPage,
                        status,
                        search
                    );
                    this.cuponsData = response.content || [];
                    this.totalPages = response.totalPages || 1;
                } catch (err) {
                    toast.error('Erro ao carregar listagem de cupons');
                } finally {
                    this.isLoading = false;
                }
            },
            async createNewCupom() {
                const payload = {
                    title: this.newCupom.title,
                    code: this.newCupom.code,
                    discount: this.newCupom.discount,
                    expired: this.newCupom.expired,
                    status: 1,
                };
                try {
                    this.isLoading = true;
                    await ApiCupom.createNewCupom(this.token, payload);
                    this.newCupomDialog = false;
                    this.newCupom = {
                        title: '',
                        code: '',
                        discount: '',
                        expired: '',
                    };
                    toast.success('Cupom criado com sucesso!');
                    this.getCupomData();
                } catch (err) {
                    toast.error('Erro ao criar cupom!');
                } finally {
                    this.isLoading = false;
                }
            },
            async updateCupom(id) {
                const payload = {
                    title: this.editingCupom.title,
                    code: this.editingCupom.code,
                    discount: this.editingCupom.discount,
                    expired: this.editingCupom.expired,
                    status: this.editingCupom.status,
                };
                try {
                    this.isLoading = true;
                    await ApiCupom.editCupom(this.token, id, payload);
                    this.editCupomDialog = false;
                    toast.success('Cupom atualizado com sucesso!');
                    this.getCupomData();
                } catch (err) {
                    toast.error('Erro ao atualizar cupom!');
                } finally {
                    this.isLoading = false;
                }
            },
            async confirmDelete() {
                if (this.deletedCupom) {
                    const payload = {
                        title: this.deletedCupom.title,
                        code: this.deletedCupom.code,
                        discount: this.deletedCupom.discount,
                        expired: this.deletedCupom.expired,
                        status: 0,
                    };
                    try {
                        this.isLoading = true;
                        await ApiCupom.editCupom(
                            this.token,
                            this.deletedCupom.id,
                            payload
                        );
                        toast.success('Cupom excluído com sucesso');
                        this.getCupomData();
                    } catch (error) {
                        toast.error('Erro ao excluir cupom:', error);
                    } finally {
                        this.isDeleteDialogVisible = false;
                        this.isLoading = false;
                        this.deletedCupom = { title: '', code: '' };
                    }
                }
            },
            onSearch: debounce(function () {
                this.getCupomData();
            }, 300),
        },
    };
</script>

<style scoped>
    @import url('@/css/weeduc/admin/cupons.css');
</style>
